/**
 * Formats an acreage value for display.
 *
 * Contract:
 * - String input is parsed with Number()
 * - null, undefined, NaN, non-finite → returns '—'
 * - |value| < 10  → 1 decimal place + ' acres' (e.g. '7.3 acres')
 * - |value| >= 10 → 0 decimals with comma grouping + ' acres' (e.g. '1,248 acres')
 */
export function formatAcres(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return '—';
  const parsed = typeof value === 'string' ? Number(value) : value;
  if (!isFinite(parsed) || isNaN(parsed)) return '—';

  if (Math.abs(parsed) < 10) {
    return `${parsed.toFixed(1)} acres`;
  }

  const formatted = parsed.toLocaleString('en-US', { maximumFractionDigits: 0 });
  return `${formatted} acres`;
}
